const order = {
  'orderList.title': 'Order List',
  'orderList.api.error.getOrderList': 'Failed to retrieve order list',
};

export default order;
